import { type SVGProps } from "react";

export const CalendarPlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={41}
    height={41}
    fill="none"
    {...props}
  >
    <circle cx={20.5} cy={20.5} r={20} fill="#fff" stroke="#2A81BA" />
    <path
      fill="#2A81BA"
      d="M28.667 11H12.333C11.038 11 10 12.012 10 13.25v13.5c0 1.238 1.038 2.25 2.333 2.25h16.334C29.95 29 31 27.988 31 26.75v-13.5c0-1.238-1.038-2.25-2.333-2.25Zm0 15.75H12.333V15.5h16.334v11.25Z"
    />
    <circle cx={29.05} cy={26.95} r={3.85} fill="#fff" />
    <path
      fill="#2A81BA"
      d="M28.5 22a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Zm2.75 6.05h-2.2v2.2h-1.1v-2.2h-2.2v-1.1h2.2v-2.2h1.1v2.2h2.2v1.1Z"
    />
  </svg>
);
